/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Review_Outcome_ApprovedInputs */



/**
* | output |
* | --- |
* | "Approved - Chat Unblocked" |
*
* @param {Audit_Details_Review_Outcome_ApprovedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_review_outcome_approved = /** @type {((inputs?: Audit_Details_Review_Outcome_ApprovedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Review_Outcome_ApprovedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Genehmigt - Chat entsperrt")
	return /** @type {LocalizedString} */ ("Approved - Chat Unblocked")
});